import { countryConfig } from "src/country-config/country-config";

export const defaultData = countryConfig.home;
